import { apiService } from './apiService';

export const signatureService = {
  async createRequest(data: { shipmentId: string | number; documentType?: string; signingRole?: 'controller' | 'approver' }) {
    return apiService.post('/signature/request', data);
  },

  async downloadBulkRequestBundle(data: { shipmentIds: Array<string | number>; documentType?: string; signingRole?: 'controller' | 'approver' }) {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${baseUrl}/signature/request/bulk-bundle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      let message = 'Toplu imza paketi indirilemedi';
      try {
        const payload = await response.json();
        message = payload?.message || message;
      } catch {
        // ignore
      }
      throw new Error(message);
    }

    const contentType = String(response.headers.get('content-type') || '').toLowerCase();
    if (contentType.includes('application/zip') || contentType.includes('application/octet-stream')) {
      return {
        mode: 'blob' as const,
        blob: await response.blob(),
      };
    }

    return {
      mode: 'json' as const,
      payload: await response.json(),
    };
  },

  async getRequestStatus(requestId: string | number) {
    return apiService.get(`/signature/request/${requestId}/status`);
  },

  getToolDownloadUrl() {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/tool/download`;
  },

  getToolZipDownloadUrl() {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/tool/download-zip`;
  },

  getRequestDownloadUrl(requestId: string | number, token: string) {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/request/${requestId}?token=${encodeURIComponent(token)}`;
  },

  getRequestPreviewUrl(requestId: string | number, token: string) {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/request/${requestId}?token=${encodeURIComponent(token)}&preview=1`;
  },

  getRequestBundleDownloadUrl(requestId: string | number, token: string) {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/request/${requestId}/bundle?token=${encodeURIComponent(token)}`;
  },

  getBulkRequestBundleDownloadUrl(token: string) {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    return `${apiBase.replace(/\/api\/?$/, '')}/api/signature/request/bulk-bundle-download?token=${encodeURIComponent(token)}`;
  },
};
